/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

export const SubscriptionInfo = () => (
  <Content>
    <Section>Подробнее о подписки:</Section>
    <p>Подписка предоставляет доступ к материалам на платформе на 1 месяц и прибавляет 1 месяц консультаций при каждом списании. В нее входит доступ к 14-ти полноценных курсов и марафонов.</p>

    <Section>Преимущества подписки:</Section>
    <ul>
      <li>
        <strong>Доступ к 14-ти курсам:</strong>
        {' '}
        Получите доступ к 14-ти курсам на нашей платформе на протяжении 1 месяца.
      </li>
      <li>
        <strong>Обновления:</strong>
        {' '}
        Наслаждайтесь новыми курсами и обновлениями, которые добавляются регулярно.
      </li>
      <li>
        <strong>Экономия:</strong>
        {' '}
        Подписка выгоднее, чем покупка каждого курса отдельно.
      </li>
    </ul>

    <Section>Как это работает:</Section>
    <ol>
      <li>
        <strong>Подпишитесь:</strong>
        {' '}
        Оформите подписку, выбрав удобный для вас способ оплаты.
      </li>
      <li>
        <strong>Получите доступ:</strong>
        {' '}
        Наслаждайтесь неограниченным доступом ко всем материалам на 1 месяц.
      </li>
      <li>
        <strong>Продление:</strong>
        {' '}
        Подписка продлевается автоматически каждый месяц. Вы можете отменить подписку в любой момент.
      </li>
      <li>
        <strong>Отмена:</strong>
        {' '}
        При отмене подписки доступ ко всем материалам прекратится в конце текущего оплаченного периода, кроме курсов, которые были приобретены отдельно до подписки.
      </li>
    </ol>
  </Content>
);

const Content = styled.div`
  width: 100%;
  margin-top: 24px;
`;

const Section = styled.h6`
`;
